var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.206,
    height: 26.206,
    viewBox: "0 0 26.206 26.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pricing-workspace-svgrepo-com",
    transform: "translate(-2.1 -2.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M9.227,2.1a.894.894,0,0,1,.932.932v.6a.894.894,0,0,1-.932.932h-2.8A1.864,1.864,0,0,0,4.567,6.321V23.974a1.864,1.864,0,0,0,1.754,1.864H23.974a1.864,1.864,0,0,0,1.864-1.754V21.178a.894.894,0,0,1,.932-.932h.6a.894.894,0,0,1,.932.932v3.4A3.733,3.733,0,0,1,24.577,28.3H5.828A3.733,3.733,0,0,1,2.1,24.577V5.827A3.733,3.733,0,0,1,5.828,2.1Z",
    fill: "#007cab",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(8.266 3.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M22.313,4.9l4.605.11a2.193,2.193,0,0,1,.987.384h0L29.714,7.2l1.809,1.809a1.321,1.321,0,0,1,.384.987h0l.11,4.605a1.447,1.447,0,0,1-.384,1.042h0l-7.566,7.62a1.387,1.387,0,0,1-1.974,0h0L17.927,19.1,13.76,14.932a1.387,1.387,0,0,1,0-1.974h0l7.566-7.62a1.283,1.283,0,0,1,.987-.439Zm-2.577,7.4-.768.768a.411.411,0,0,0,0,.493L23.409,18a.411.411,0,0,0,.493,0l.768-.768a.411.411,0,0,0,0-.493L20.229,12.3a.307.307,0,0,0-.493,0Zm2.083-2.083-.713.768a.411.411,0,0,0,0,.493l4.441,4.441a.411.411,0,0,0,.493,0l.768-.768a.411.411,0,0,0,0-.493l-4.441-4.441c-.164-.164-.329-.164-.548,0ZM29,7.97a1.393,1.393,0,1,0,.41.987A1.4,1.4,0,0,0,29,7.97Z",
    transform: "translate(-13.348 -4.9)",
    fill: "#007cab"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpBlue);
export default __webpack_public_path__ + "static/media/PP_Blue.fa44ef4075bccf93d4319434593eac39.svg";
export { ForwardRef as ReactComponent };